import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';

// Components
import Sidebar from '../../components/Sidebar';
import Main from './BillOfSale/Main';
import Form from './BillOfSale/Form';

import {
  getDataWithComp,
  getDocStatusColour,
  getAlert,
  getClearLocalStorage
} from '../../../utils/SamuiUtils';

import { getReport } from '../../../utils/ReportUtils';

const BillOfSale = () => {
  const [mode, setMode] = useState('S');
  const [dataMasterList, setDataMasterList] = useState([]);
  const [statusColours, setStatusColours] = useState([]);
  const [statusPaidColours, setStatusPaidColours] = useState([]);
  const [maxDocNo, setMaxDocNo] = useState();
  const [startDate, setStartDate] = useState(() => {
    const storedStartDate = localStorage.getItem('startDate');
    return storedStartDate || moment().startOf('month').format('YYYY-MM-DD');
  });
  const [endDate, setEndDate] = useState(() => {
    const storedEndDate = localStorage.getItem('endDate');
    return storedEndDate || moment().endOf('month').format('YYYY-MM-DD');
  });
  const hasLoadedInitialData = useRef(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      await getClearLocalStorage();
      await fetchRealtime();
      hasLoadedInitialData.current = true;
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  useEffect(() => {
    if (hasLoadedInitialData.current && mode === 'S') {
      fetchRealtime();
    }
  }, [startDate, endDate]);

  const fetchRealtime = async (rangeStart = startDate, rangeEnd = endDate) => {
    try {
      localStorage.setItem('startDate', rangeStart);
      localStorage.setItem('endDate', rangeEnd);

      const whereClause = `AND CONVERT(date, Doc_Date) BETWEEN '${rangeStart}' AND '${rangeEnd}' ORDER BY CONVERT(date, Doc_Date) DESC, Doc_No DESC`;

      const [masterList, docStatusColour, docStatusPaidColour] = await Promise.all([
        getDataWithComp('API_0701_SO_H', whereClause),
        getDocStatusColour('SO', 'Doc_Status'),
        getDocStatusColour('SO', 'Doc_Status_Paid'),
      ]);

      if (masterList && masterList.length > 0) {
        const sortedData = [...masterList].sort((a, b) => b.Doc_Id - a.Doc_Id);
        setDataMasterList(sortedData);
      } else {
        setDataMasterList([]);
      }

      setStatusColours(docStatusColour && docStatusColour.length > 0 ? docStatusColour : []);
      setStatusPaidColours(docStatusPaidColour && docStatusPaidColour.length > 0 ? docStatusPaidColour : []);
    } catch (error) {
      getAlert('FAILED', error.message);
    }
  };

  const onPageInsert = () => {
    setMode('I')
  };

  const onRowSelected = (docNo) => {
    setMaxDocNo(docNo);
    setMode('U');
  };
  return (
    <div className="PurchaseRequest">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === 'S' ? (
                <Main
                  masterList={dataMasterList}
                  statusColours={statusColours}
                  statusPaidColours={statusPaidColours}
                  name={'ใบขาย'}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(docNo) => onRowSelected(docNo)}
                  getReport={getReport}
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  setMode={setMode}
                  name={'ใบขาย'}
                  maxDocNo={mode === "I" ? "" : maxDocNo}
                  getReport={getReport}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillOfSale;
